import { AccountContextProvider } from "../../../../components/contexts/AccountContext";
import { useCurrentUser } from "../../../../components/contexts/CurrentUserContext";
import { useUserFeatures } from "../../../../components/contexts/UserFeaturesContext";
import TransactionExportPage from "../TransactionExportPage";

import type Account from "byzantine/src/Account";

interface TransactionExportPageContainerProps {
  accounts?: Account[];
}

const TransactionExportPageContainer = ({
  accounts = [],
}: TransactionExportPageContainerProps) => {
  const { currentUser } = useCurrentUser();
  const features = useUserFeatures();

  if (!features.reports || !currentUser?.isBusiness()) {
    return null;
  }

  return (
    <AccountContextProvider accounts={accounts}>
      <TransactionExportPage />
    </AccountContextProvider>
  );
};

export default TransactionExportPageContainer;
